export const LOGOUT_BEACON_KEY = 'auth:logout'

let counter = 0

/**
 * Writing to localStorage fires a native `storage` event in every OTHER
 * same-origin tab, which is what lets one sign-out reach the rest of them.
 *
 * The value must change on every write or a repeat sign-out fires nothing, so
 * the wall clock is paired with a monotonic counter to stay unique even for two
 * writes inside the same millisecond.
 */
export function emitLogoutBeacon(): void {
  try {
    counter += 1
    localStorage.setItem(LOGOUT_BEACON_KEY, `${Date.now()}:${counter}`)
  } catch {
    // Private mode or a full quota. A failed beacon only degrades to the
    // reactive 401 sign-out other tabs already have — never block the local
    // sign-out on it.
  }
}
